import { TFunction } from 'i18next';
import * as yup from 'yup';

type RequestResetPasswordForm = {
  username: string;
};

export const getLocalizedSchema = (t: TFunction): yup.ObjectSchema<RequestResetPasswordForm> =>
  yup
    .object({
      username: yup.string().email(t('form.validation.emailInvalid')).required(t('form.validation.emailInvalid')),
    })
    .required();

export type FormData = yup.InferType<ReturnType<typeof getLocalizedSchema>>;
